export * from './auswertungen.querys.module';
export * from './soll-ist';
